export const show = (msg) => {
  console.log(msg);
};

export default {
  filters: {},
  methods: {
    $_show: show,
  },
};
